import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "@core/router";
import { AuthProvider } from "@features/auth/AuthProvider";
import { NoticeProvider } from "@shared/ui/NoticeDialog";
import "@styles/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <NoticeProvider>
          <RouterProvider router={router} />
        </NoticeProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
